

import { Loader } from "lucide-react";

export default function QuotationLoading() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-3">
        <Loader className="w-8 h-8 text-amber-600 animate-spin" />
        <p className="text-stone-600">Loading quotation details...</p>
      </div>
    </div>
  );
}
